export const getUnlockableRewardsSubtitle = (params: Params) => {
  const {
    availablePoints,
    nextReward,
    unlockableRewardsSubtitleNoPoints,
    unlockableRewardsSubtitleDefault,
    unlockableRewardsSubtitleTooManyPoints,
  } = params;

  if (availablePoints === 0) {
    return unlockableRewardsSubtitleNoPoints;
  }

  if (!nextReward) {
    return unlockableRewardsSubtitleTooManyPoints;
  }

  return unlockableRewardsSubtitleDefault
    .replaceAll('(name)', nextReward.name)
    .replaceAll('(points)', nextReward.pointsLeft.toString());
};

// ─── Types ──────────────────────────────────────────────────────────────────

type Params = {
  availablePoints: number;
  nextReward: { name: string; pointsLeft: number } | undefined;
  unlockableRewardsSubtitleNoPoints: string;
  unlockableRewardsSubtitleDefault: string;
  unlockableRewardsSubtitleTooManyPoints: string;
};
